import React from 'react';
import { Link } from 'react-router-dom';
import { Icons } from '../../../Components/Icons/Icons';
import './ModuleCard.scss';

interface ModuleCardProps {
  title: string;
  description: string;
  icon: JSX.Element;
  link: string;
}

export const ModuleCard: React.FC<ModuleCardProps> = ({ title, description, icon, link }) => {
  return (
    <Link to={link} className="module-card">
      <div className="module-card__icon">{icon}</div>
      <h3 className="module-card__title">{title}</h3>
      <p className="module-card__description">{description}</p>
      <div className="module-card__link">
        Go To The Module
        {Icons.ArrowRight}
      </div>
    </Link>
  );
};
